export const GREEN = ['Going', 'Selected'];
export const YELLOW = ['Pending', 'No Response', 'Company Will Inform'];
export const RED = ['Not Going', 'Not Selected'];
export const PRIMARY_STATUSES = ['Going', 'Not Going', 'No Response'];
export const FINAL_STATUSES = ['Selected', 'Not Selected', 'Company Will Inform', 'Pending'];
export const NOT_GOING_REASONS = ['Not Interested', 'Location Issue', 'Salary Issue'];

export const statusGroup = (s) => (GREEN.includes(s) ? 'green' : RED.includes(s) ? 'red' : 'yellow');

export const GROUP_STYLE = {
  green: { row: 'bg-[#14532D]/70 border-l-4 border-l-[#4ADE80]', badge: 'bg-[#4ADE80] text-black', dot: '#4ADE80' },
  yellow: { row: 'bg-[#4A3B05]/60 border-l-4 border-l-[#FDE047]', badge: 'bg-[#FDE047] text-black', dot: '#FDE047' },
  red: { row: 'bg-[#5B1A1A]/70 border-l-4 border-l-[#F87171]', badge: 'bg-[#F87171] text-white', dot: '#F87171' },
};

export const aggregateCompanies = (rows) => {
  const acc = {};
  for (const r of rows) {
    const b = (acc[r.company_name] ||= { company_name: r.company_name, count: 0, going: 0, pending: 0, not_going: 0 });
    b.count += 1;
    const g = statusGroup(r.status);
    b[g === 'green' ? 'going' : g === 'red' ? 'not_going' : 'pending'] += 1;
  }
  return Object.values(acc).sort((a, b) => b.count - a.count);
};

export const aggregateReport = (rows) => {
  const acc = {};
  for (const r of rows) {
    const k = r.lineup_by || 'Unassigned';
    const b = (acc[k] ||= { lineup_by: k, total: 0, going: 0, selected: 0, not_going: 0, no_response: 0 });
    b.total += 1;
    if (GREEN.includes(r.status)) b.going += 1;
    if (r.status === 'Selected') b.selected += 1;
    if (RED.includes(r.status)) b.not_going += 1;
    if (r.status === 'No Response') b.no_response += 1;
  }
  return Object.values(acc)
    .map((b) => ({ ...b, going_pct: b.total ? Math.round((100 * b.going) / b.total) : 0, selected_pct: b.total ? Math.round((100 * b.selected) / b.total) : 0 }))
    .sort((a, b) => b.total - a.total || b.going_pct - a.going_pct);
};

export const waLink = (mobile, text) => {
  const d = String(mobile || '').replace(/\D/g, '');
  if (!d) return null;
  const cc = d.length === 10 ? `91${d}` : d;
  return `https://wa.me/${cc}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
};

export const telLink = (mobile) => {
  const d = String(mobile || '').replace(/\D/g, '');
  return d ? `tel:${d.length === 10 ? '+91' + d : '+' + d}` : null;
};

export const fmtDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}-${m}-${y}`;
};

export const downloadBlob = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
